export default __webpack_public_path__ + "static/media/sd-404.4a5bfb45.gif";